import { Link } from "react-router-dom";

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionTitle({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
}: SectionTitleProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div>
        <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">{title}</h2>
        {subtitle && <p className="mt-1 text-sm text-foreground-600">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}